"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreateAttributeEnumeration {
    static getAttributeTypeMap() {
        return CreateAttributeEnumeration.attributeTypeMap;
    }
}
CreateAttributeEnumeration.discriminator = undefined;
CreateAttributeEnumeration.attributeTypeMap = [
    {
        "name": "value",
        "baseName": "value",
        "type": "number"
    },
    {
        "name": "label",
        "baseName": "label",
        "type": "string"
    }
];
exports.CreateAttributeEnumeration = CreateAttributeEnumeration;
//# sourceMappingURL=createAttributeEnumeration.js.map